import styled from '@emotion/styled';

export const ContentContainer = styled.div`
  height: 380px;
`;
